import React from "react"

import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"
import { ColorName } from "@tenforce/toolbox-default-style"

import {
    ICheckListViewActions,
    IOption,
    IOptionColor,
    IQuestion,
} from "../../.."

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const ToggleValue = ({
    data,
    id,
    contextMenuActions: { updateOptionValue },
}: Props): JSX.Element => {
    const getColor = (color: IOptionColor | null): undefined | ColorName => {
        switch (color) {
            case "Gray":
            case "Black":
                return ColorName.Platinum
            case "Red":
                return ColorName.CadmiumRed
            case "Orange":
                return ColorName.Goldenrod
            case "Green":
                return ColorName.Jade
            case "Blue":
                return ColorName.DeepSkyBlue
            case "Pink":
                return ColorName.Eminence
            case "Yellow":
                return ColorName.Aureolin
            default:
                // because the color in ItemBlockPart is optional
                // I cannot return null here
                return undefined
        }
    }

    return (
        <Selector data-ft-component="toggle" isExpanded={true}>
            {(data as IOption[]).map((option) => {
                return (
                    <ItemBlockPart
                        key={option.id}
                        isSelected={option.isSelected}
                        partProps={{
                            color: getColor(option.color),
                        }}
                        data-ft-component="toggleOption"
                        data-ft-id={option.id}
                        data-ft-is-selected={option.isSelected}
                        data-ft-title={option.label}
                        // to avoid sending both onSelected and onUnselected to the backend
                        // we use onClick here and the backend will handle the unselecting
                        onClick={(): void => {
                            updateOptionValue(id, option.id, !option.isSelected)
                        }}
                    >
                        {option.label}
                    </ItemBlockPart>
                )
            })}
        </Selector>
    )
}

export default ToggleValue
